import bsUtils from 'bootstrap/js/src/util';
import { screenLgMax } from '@utils/match-media';
import MegaNavItem from './mega-nav-item';
import * as templates from './tempates';

const EVENT_KEY = '_megaMenu_';
const EVENT_CLICK = `click.${EVENT_KEY}`;

const DATA_TOGGLE_SELECTOR = `[data-control="toggle"]`;
const DATA_MENU_SELECTOR = `[data-region="menu"]`;

export {
    DATA_TOGGLE_SELECTOR as toggleSelector,
    DATA_MENU_SELECTOR as menuSelector
};

export default class MegaNav {
    #activeItems = [];

    constructor({ $el, data }) {
        this.$el = $el;

        this.data = data?.Data || {};
        this.labels = data.Labels || {};
        this.items = [];

        this.renderLazyNavItems();

        // ui controls
        this.$back = this.$el.find('[data-control="back"]')
        this.$toggle = this.$el.find(DATA_TOGGLE_SELECTOR);

        // dynamic regions
        this.$inner = this.$el.find('[data-region="inner"]');
        this.$menu = this.$el.find(DATA_MENU_SELECTOR);
        this.$nav = this.$el.find('[data-region="nav"]');

        this.init();
    }

    get activeItems() {
        return this.#activeItems;
    }

    set activeItems(val) {
        this.#activeItems = val;

        this.updateState();
    }

    get isActive() {
        return this.#activeItems.length > 0;
    }

    init() {
        this.setupNavItems();
        this.setupListeners();
        this.checkListedItem();
    }

    checkListedItem() {
        let submenuList = $('.mega-nav__item.mega-nav__item-ul');

        submenuList.each((idx,list) => {
            let numOfListedItems = $(list).children('li').length;
            let item = $(list).find('li.mega-nav__submenu-item');

            if (numOfListedItems <= 3) {
                if (numOfListedItems == 1) {
                    $(item).addClass('single-col');
                } else if (numOfListedItems >= 2) {
                    $(item).addClass('multi-col');
                }
                $(list).find('ul').addClass('d-flex flex-wrap list-unstyled flex-column adjust-max-height');
                $(list).find('ul li').addClass('add-margin');
            }
        });
    }

    onBackClick() {
        this.activeItems.at(-1).hide();
    }

    onNavItemToggle(megaNavItem) {
        const activeItems = [ ...this.activeItems ];
        if(megaNavItem.active) {
            activeItems.push(megaNavItem);
        } else {
            activeItems.pop();
        }
        this.activeItems = activeItems;
    }

    setupNavItems() {
        const transitionTime = bsUtils.getTransitionDurationFromElement(this.$inner.eq(0));
        this.$toggle.each(index => {
            this.items.push(
                new MegaNavItem({
                    $toggle: this.$toggle.eq(index),
                    $menu: this.$menu.eq(index),
                    matchHeight: this.$toggle.eq(index).data('match-height') ?? false,
                    topLevel: this.$toggle.eq(index).data('top-level') ?? false,
                    transitionTime
                })
            );
            this.items[index].subscribe(navItem => this.onNavItemToggle(navItem));
        });
    }

    setupListeners() {
        this.$back.on(EVENT_CLICK, () => this.onBackClick());
    }

    renderLazyNavItems() {
        const $navItems = this.$el.find('[data-placeholder="navItem"]');
        $navItems.each(index => {
            const $item = $navItems.eq(index);
            const prop = $item.data('property');
            const rootData = this.data[prop];

            if(rootData) {
                let navLevel = 0;

                /**
                 * recursively render navigation items based on a consistently named parent -> children schema
                 */
                const transformNavItems = ({ navItem, prevItemName }) => {
                    let link = '';
                    let submenu = '';

                    if(navItem.Children && navItem.Children.length) {
                        link = templates.subNavToggle({
                            levelMod: navLevel ? `-l${navLevel}` : '',
                            text: navItem.DisplayName,
                            url: navItem.Url
                        });

                        let items = '';

                        navLevel++;

                        navItem.Children.forEach(item => {
                            items += transformNavItems({
                                navItem: item,
                                prevItemName: navItem.DisplayName
                            });
                        });

                        const subMenuContents = `
                            ${templates.backNavItem({ text: prevItemName })}
                            ${templates.headingNavItem({
                                levelMod: navLevel ? `-l${navLevel}` : '',
                                text: navItem.DisplayName,
                                url: navItem.Url
                            })}
                            ${items}
                        `;


                        submenu = templates.subNav({
                            content: subMenuContents,
                            levelMod: navLevel ? `-l${navLevel}` : ''
                        });

                        navLevel--;
                    } else if(navItem.Url) {
                        link = templates.navItemLink({
                            levelMod: navLevel ? `-l${navLevel}` : '',
                            target: navItem.Target,
                            text: navItem.DisplayName,
                            url: navItem.Url
                        });
                    }

                    return templates.navItem(
                        link + submenu
                    );
                }

                const markup = transformNavItems({
                    navItem: rootData,
                    prevItemName: this.labels.MainMenu
                });
                $item.replaceWith(markup);
            }
        });
    }

    updateState() {
        const count = this.activeItems.length;
        if(count && screenLgMax.matches) {
            this.$inner.css('transform', `translateX(-${count * 100}%)`);
        } else {
            this.$inner.removeAttr('style');
        }
    }
}

let nav = null;

const el = document.querySelector('.js-mega-nav');
if(el) {
    const dataId = el.dataset.id;
    const dataEl = document.getElementById(dataId);
    const data = dataEl ? JSON.parse(dataEl.innerHTML) : {};
    nav = new MegaNav({
        $el: $(el),
        data
    });
}

const megaNavActive = () => nav.isActive;

export {
    megaNavActive
};
